var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "trash-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.83203 6.26562H4.69368H19.5869",
    stroke: "#888B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.7259 6.26627V19.2978C17.7259 19.7916 17.5298 20.2651 17.1806 20.6142C16.8315 20.9634 16.358 21.1595 15.8643 21.1595H6.55599C6.06225 21.1595 5.58873 20.9634 5.2396 20.6142C4.89047 20.2651 4.69434 19.7916 4.69434 19.2978V6.26627M7.48682 6.26627V4.40462C7.48682 3.91088 7.68295 3.43736 8.03208 3.08823C8.38121 2.73911 8.85473 2.54297 9.34847 2.54297H13.0718C13.5655 2.54297 14.039 2.73911 14.3882 3.08823C14.7373 3.43736 14.9334 3.91088 14.9334 4.40462V6.26627",
    stroke: "#888B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.34863 10.9199V16.5049",
    stroke: "#888B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.0713 10.9199V16.5049",
    stroke: "#888B9B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDl);
export default __webpack_public_path__ + "static/media/dl.d3c0011f03b37082f3cff8fb3285c877.svg";
export { ForwardRef as ReactComponent };